import { defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    recipes: {
      skeleton: {
        variants: {
          variant: {
            pulse: {
              background: 'surface.accent',
            },
            shine: {
              '--start-color': 'colors.surface.muted',
              '--end-color': 'colors.surface.accent',
            },
          },
        },
      },
    },
  },
});

export default config;
